import { ContactFormLinkFormatting } from "@faire/deprecated-retailer-visitor-shared/components/Links";
import { isLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { EmailPreferencesForm } from "@faire/deprecated-retailer-visitor-shared/views/settings/email-preferences/components/EmailPreferencesForm";
import { useEmailPreferencesQuery } from "@faire/deprecated-retailer-visitor-shared/views/settings/email-preferences/hooks/useEmailPreferencesQuery";
import { Layout } from "@faire/deprecated-retailer-visitor-shared/views/settings/Layout";
import { Core } from "@faire/design-tokens";
import { LoadingSpinner } from "@faire/slate/components/loading-spinner";
import emailPreferencesPath, {
  route as emailPreferencesRoute,
} from "@faire/web-api--source/routes/www/retailer/settings/email-preferences";
import { QueryParameters as EmailPreferencesPageQueryParams } from "@faire/web-api--source/routes/www/retailer/settings/email-preferences";
import { Row } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { useQueryParams } from "@faire/web/ui/hooks/useQueryParams";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import qs from "query-string";
import * as React from "react";
import { Redirect, useLocation } from "react-router-dom";

export const MANAGE_EMAIL_PREFERENCES = "manageEmailPreferences";
export const OVERWRITE_COPY_KEY = "overwriteCopy";

export const EmailPreferencesPage: React.FC = () => {
  const location = useLocation();
  const {
    emailPreferencesResponse,
    isQueryPreferencesLoading,
    isQueryPreferencesError,
    preferencesQueryParameters,
  } = useEmailPreferencesQuery();
  const { tab } = useQueryParams(EmailPreferencesPageQueryParams.parse);

  const errorMessage = isQueryPreferencesError ? (
    <StrictLocalMsg
      id="1u0FcY"
      defaultMessage="Something went wrong. Please try again or <ContactFormLinkFormatting>contact us</ContactFormLinkFormatting>."
      description={{
        text: "This is displayed to tell the user there was an unhandled error when fetching email preferences.",
      }}
      values={{
        ContactFormLinkFormatting,
      }}
    />
  ) : undefined;

  if (!isLoggedInRetailer()) {
    // If a user is logged out pop the log in modal.
    // redirectTo is not defined if the log in modal does not exist
    if (!location.search.includes("redirectTo")) {
      return (
        <Redirect
          to={{
            pathname: emailPreferencesRoute,
            search: qs.stringify({
              signIn: 1,
              redirectTo: emailPreferencesPath({ tab }),
              [OVERWRITE_COPY_KEY]: MANAGE_EMAIL_PREFERENCES,
              outgoing_email: preferencesQueryParameters.outgoing_email,
            }),
          }}
        />
      );
    } else {
      return (
        <Row
          justify="center"
          align="center"
          style={{ margin: "10px", position: "relative" }}
        >
          <LoadingSpinner size="small" data-test-id="loading-spinner" />
        </Row>
      );
    }
  }

  if (isQueryPreferencesLoading) {
    return <Layout page="email_preferences" isLoading />;
  }

  if (isQueryPreferencesError || !emailPreferencesResponse) {
    return (
      <Layout page="email_preferences">
        <Row
          justify="center"
          align="center"
          style={{ margin: "10px", position: "relative" }}
        >
          <Typography color={Core.text.critical}>{errorMessage}</Typography>
        </Row>
      </Layout>
    );
  }

  return (
    <Layout page="email_preferences" fullWidth>
      <EmailPreferencesForm />
    </Layout>
  );
};
